angular
    .module('app')
    .component('superSearch', {
        templateUrl: '/templates/components/superSearch/superSearch.html',
        controller: 'SuperSearchController',
        controllerAs: 'vm',
    });